<!--时间表对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-假期计划表-全局' : '新建' + '-假期计划表-全局'" :has-form="true" class="time-event-dialog-modal"
      @close="close" @confirm="handleConfirm" top="15%">
      <gs-tabs v-model="activeName" type="content-tab">
        <!-- <gs-tab-pane label="常规" name="first">
          <gs-form :model="form" label-width="95px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <gs-input v-model="description" />
            </gs-form-item>
          </gs-form>
        </gs-tab-pane> -->
        <gs-tab-pane label="假期计划" name="first">
          <div class="border-main">
            <gs-form :model="form" label-width="0px" label-position="left" gap="small">
              <gs-form-item label="" prop="target" class="form-item-radio">
                <div style="width: 100%;display: flex;justify-content: center;align-items: center;">
                  <el-date-picker placeholder="月份" v-model="timeRange" value-format="yyyy-MM" type="month" size="mini"
                    @change="onMonthChange">
                  </el-date-picker>
                </div>
              </gs-form-item>

              <div class="calendar">
                <!-- 星期头 -->
                <div class="calendar-header">
                  <div v-for="w in weeks" :key="w" class="week">
                    {{ w }}
                  </div>
                </div>
                <!-- 日期区域 -->
                <div class="calendar-body">
                  <div v-for="item in calendarList" :key="item.id" class="day" :class="{
                    active: !item.empty && isBlueDay(item),
                    empty: item.empty
                  }" @click="!item.empty && onDayClick(item)">
                    <div class="day-number" v-if="!item.empty">
                      {{ item.day }}
                    </div>
                    <div class="lunar" v-if="!item.empty && item.holidayName">
                      {{ item.holidayName }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- <gs-form-item label="假期设置" prop="target" class="form-item-radio">
                <div style="line-height: 1px;margin-top: 5px;">
                  <gs-date-picker v-model="dataTime" :default-time="[formDatas.defaultTime, formDatas.defaultTime1]"
                    type="date-range" />
                  <div style="float: right;line-height: 20px;margin-left: 20px;">
                    <span @click="creatTimeChart" style="cursor: pointer;color: #ff7f00;">创建</span>
                  </div>
                </div>
              </gs-form-item>
              <div style="width: 400px">
                <el-table :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #363437' }"
                  :data="timeChartListArray" style="width: 100%">
                  <el-table-column prop="startTime" label="时间范围" align="center" width="280">
                  </el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <i class="el-icon-delete" @click="delTimeData(scope.row)"></i>
                    </template>
</el-table-column>
</el-table>
</div> -->
            </gs-form>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <!--  <gs-button type="primary" size="mini">帮 助</gs-button> -->
      </span>
    </gs-modal>
    <gs-modal v-loading="loadingData" v-model="visibleData" :before-close="beforeCloseData"
      :title="isEdit ? '编辑' : '新建'" class="my-test-class" @close="closeData" @confirm="handleConfirmData">
      <gs-form :model="form">
        <fieldset>
          <legend>范围</legend>
          <div style="padding:10px">
            <gs-checkbox v-model="formDatas.isWeek">每周</gs-checkbox>
            <gs-checkbox :disabled="formDatas.isWeek" v-model="formDatas.isYear">每年</gs-checkbox>
          </div>
          <gs-date-picker v-model="formDatas.date" :disabled="formDatas.isWeek"
            :default-time="[formDatas.defaultTime, formDatas.defaultTime1]" style="padding:10px" type="date-range" />
        </fieldset>
      </gs-form>
    </gs-modal>
    <gs-modal v-model="visibleAll" :before-close="beforeCloseAll" :title="'所有事件'" class="my-test-class"
      @close="closeAll" @confirm="handleConfirmAll">
      <fieldset>
        <legend>所有事件</legend>
        <gs-table ref='selectionTable' :data="timeChartList" @selection-change="getSelections"
          @row-click="handleRowClick">
          <gs-table-column type="selection" />
          <gs-table-column prop="formDate" label="开始日期" />
          <gs-table-column prop="toDate" label="结束日期" />
          <gs-table-column prop="startTime" label="开始时间" />
          <gs-table-column prop="stopTime" label="结束时间" />
          <gs-table-column prop="weekDays" label="星期" />
        </gs-table>
        <!-- <gs-pagination
          ref="pagination"
          :current="currentPage"
          :total="parseInt(tableList.length/5)+1"
          :before-jump="page => beforeJump(page, 'pagination')"
          style="margin-top:20px;"
          layout="simplepager,jumper,jumpbtn"
        /> -->
        <div>
          <gs-button @click="openNewAdd">新建</gs-button>
          <gs-button @click="edit">编辑</gs-button>
          <gs-button @click="del">删除</gs-button>
        </div>
      </fieldset>
    </gs-modal>
    <gs-modal title="帮助" v-model="dialogHelp" class="my-test-class" :before-close="handleCloseHelp">
      <span></span><br>
      <span></span>
      <span slot="footer" class="dialog-footer">
        <!--<el-button @click="dialogHelp = false">取 消</el-button>
    <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
      </span>
    </gs-modal>
    <!--<newAdd
      :visible="addShow"
      :time-chart-list="eventsList"
      @closeNewAdd="closeNewAdd"
    />-->
    <!--<allEvent
      :visible="addEventShow"
      :events-list="eventsList"
      @closeAllEvent="closeAllEvent"
    />-->

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import datePicker from '../datePicker/dayPicker'
import exchangeTime from '../../utils/timeExchange.js'
import newAdd from './timeChartNewAdd'
import eventBus from './vue.js'
import allEvent from './allEvent'
import moment from 'moment'
export default {
  components: {
    datePicker, newAdd, allEvent
  },
  data() {
    return {
      dataTime: '',
      timeChartListArray: [],
      timeList: [],
      value2: '',
      //列表
      dialogHelp: false,
      visibleAll: false,
      tableList: [],
      radio: {},
      editData: {},
      currentPage: 1,
      multipleSelection: [],
      selection: [],
      select: false, //选择单个数据
      //主
      isEdit: false,
      loading: false,
      activeName: 'first',
      form: {
        checked: '',
        checked1: '',
        min1: '',
        min2: '',
        max1: '',
        max2: '',
        objList: [],
        time: '',
        select: '',
        maxNum: '',
      },
      description: '',
      name: '',
      checked: '',
      tableData: [],
      year: '',
      month: '',
      today: '',
      addShow: false,
      addEventShow: false,
      timeChartList: [],
      eventsList: [],
      //新建
      visibleData: false,
      loadingData: false,
      checkAll: true,
      checkedCities: [],
      cities: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      isIndeterminate: true,
      timeType: 1,
      formDatas: {
        isWeek: true,
        date: '',
        isYear: false,
        date1: '',
        formDate: moment(),
        toDate: moment(),
        startTime: moment(),
        stopTime: moment()
      },
      timeRange: '',
      weeks: ['日', '一', '二', '三', '四', '五', '六'],
      calendarList: [], // 后端返回的数据
      originCalendarList: [], // 后端原始数据（不可改）
      modifiedList: [],       // 本月被修改的数据
    }
  },
  computed: {
    ...mapState({
      visible: 'holidayShow',
      nodeData: 'nodeTree',
      objectData: 'objectInfo'
    })
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        this.activeName = 'first'
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'vacation') {
          this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.description = this.objectData.description
          this.name = this.objectData.name
          this.isEdit = true
          this.eventsList = this.objectData.attribute.events
          this.timeChartListArray = this.objectData.attribute.vacationList
          this.eventsList.forEach(e => {
            if (!e.id) {
              e.id = Math.random()
            }
          })
        } else {
          this.form = {}
          this.description = ''
          this.name = ''
          this.isEdit = false
          this.eventsList = []
          this.timeChartListArray = []
        }
      } else {
        this.form = {}
        this.description = ''
        this.name = ''
        this.isEdit = false
        this.eventsList = []
        this.timeChartListArray = []
        eventBus.$emit('reSetList', true)
      }
    }
  },
  created() {
    this.year = parseInt(exchangeTime(new Date()).substr(0, 4))
    this.month = parseInt(exchangeTime(new Date()).substr(5, 2))
    this.timeRange = this.getCurrentYearMonth()
    this.selectData()
  },
  mounted() {
    eventBus.$on('openNewAdd', () => {
      this.addShow = true
    })
  },
  methods: {
    ...mapMutations({
      close: 'HOLIDAY_HIDE'
    }),
    delTimeData(val) {
      this.timeChartListArray.splice(val.$index, 1)
    },
    // 创建时间
    creatTimeChart() {
      let a = moment(this.dataTime[0]).format('YYYY-MM-DD')
      let b = moment(this.dataTime[1]).format('YYYY-MM-DD')
      let time = a + '至' + b
      let obj = {
        'startTime': time
      }
      let vacationList = {
        name: '中国标准时间',
        start: moment(this.dataTime[0]).format('YYYY-MM-DD').substr(5, 10),
        end: moment(this.dataTime[1]).format('YYYY-MM-DD').substr(5, 10),
        startTime: time
      }
      this.timeList.push(vacationList)
      this.timeChartListArray.push(obj)
    },
    //列表
    beforeCloseAll() {
      this.visibleAll = false
    },
    closeAll() {
      this.visibleAll = false
    },
    handleConfirmAll() {
      this.eventsList = this.selection
      this.visibleAll = false
      this.select = true
    },
    getSelections(selection) {
      if (selection.length > 1) {
        this.$refs.selectionTable.clearSelection()
        this.$refs.selectionTable.toggleRowSelection(selection.pop())
      } else {
        this.selection = selection
      }
    },
    handleRowClick(row, column, event) {
      this.$refs.selectionTable.toggleRowSelection(row)
    },
    openNewAdd() {
      this.visibleData = true
    },
    del() {
      let arr = this.timeChartList
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === this.selection[0].id) {
          arr.splice(i, 1)
        }
      }
    },
    edit() {
      if (!this.radio) {

      } else {

      }
      this.editData = this.radio
      this.visibleData = true
      if (this.editData.formDate.indexOf('*') === 0) {
        this.editData.formDate = new Date().getFullYear() + this.editData.formDate.substr(4, 6)
      }
      if (this.editData.toDate.indexOf('*') === 0) {
        this.editData.toDate = new Date().getFullYear() + this.editData.toDate.substr(4, 6)
      }
      if (this.editData.formDate === '-') {
        this.editData.formDate = moment(new Date()).format('YYYY-MM-DD')
      }
      if (this.editData.toDate === '-') {
        this.editData.toDate = moment(new Date()).format('YYYY-MM-DD')
      }
      eventBus.$emit('editTimeChart', this.editData)
    },
    //主
    beforeClose() {
      this.select = false
      this.close()
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      // 保存新的日期
      service.updateCalendarData(this.modifiedList).then(res => {
        this.$Message.success('保存成功')
      }).catch(err => {
        this.$Message.error('保存失败')
      })
      /*  this.loading = true */
      // if (this.timeChartList) {
      //   this.timeChartList = []
      // }
      /*   this.timeChartList.forEach(e => {
          delete e.id
        })
        if (this.objectData.id && this.objectData.type === 'timeChart') {
          let param = {
            id: this.objectData.id,
            'name': this.name,
            'type': 'timeChart',
            value: this.objectData.value,
            'parentId': this.objectData.parentId,
            'description': this.description,
            'attribute': {
              events: this.timeChartList
            } // 其他信息这里，键值对形式
          }
          service.renamePoint(param).then(res => {
            this.loading = false
            this.timeList = []
            this.$Message.success('修改成功')
            this.close()
          }).catch(err => {
            this.loading = false
            this.$Message.error(err.message)
          })
        } else {
          let param = {}
          if (this.select) {
            if (this.selection.length === 0) {
              param = {
                'name': this.name,
                'type': 'timeChart',
                'parentId': this.objectData.id,
                'description': this.description,
                'attribute': {
                  events: this.timeChartList
                } // 其他信息这里，键值对形式
              }
            } else {
              param = {
                'name': this.name,
                'type': 'timeChart',
                'parentId': this.objectData.id,
                'description': this.description,
                'attribute': {
                  events: this.selection
                } // 其他信息这里，键值对形式
              }
            }
          } else {
            param = {
              'name': this.name,
              'type': 'timeChart',
              'parentId': this.objectData.id,
              'description': this.description,
              'attribute': {
                events: this.timeChartList
              } // 其他信息这里，键值对形式
            }
          }
          this.select = false
          let obj = {
            'parentId': this.objectData.id,
            'name': this.name,
            "type": "vacation",
            'description': this.description,
            "attribute": {
              "vacationList": this.timeList
            }
          }
          service.newAddPoint(obj).then(res => {
            this.loading = false
            this.$Message.success('添加成功')
            this.timeList = []
            this.close()
          }).catch(err => {
            this.loading = false
            this.$Message.error(err.message)
          })
        } */
      // this.select = false
    },
    newAddShow() {
      // this.addShow = true
      this.visibleData = true
    },
    closeNewAdd(data) {
      this.addShow = false
      this.timeChartList = data
      this.eventsList = data
    },
    openAddEvent() {
      //this.addEventShow = true
      this.visibleAll = true
    },
    closeAllEvent() {
      this.addEventShow = false
    },
    changeDate(changeDate) {
      //  console.log(changeDate)
    },
    preMon() {
      if (this.month === 1) {
        this.month = 12
        this.year--
      } else {
        this.month--
      }
    },
    nextMon() {
      if (this.month === 12) {
        this.month = 1
        this.year++
      } else {
        this.month++
      }
    },
    // 新建
    closeData() {
      this.form = {
        isWeek: true,
        date: '',
        isYear: false
      }
      this.isEdit = false
      this.checkedCities = []
      this.visibleData = false
    },
    handleConfirmData() {
      this.formDatas.formDate = this.formDatas.date[0]
      this.formDatas.toDate = this.formDatas.date[1]
      let textString = ['_', '_', '_', '_', '_', '_', '_']
      this.checkedCities.forEach(e => {
        switch (e) {
          case '星期一':
            textString[0] = 'M'
            break
          case '星期二':
            textString[1] = 'T'
            break
          case '星期三':
            textString[2] = 'W'
            break
          case '星期四':
            textString[3] = 'T'
            break
          case '星期五':
            textString[4] = 'F'
            break
          case '星期六':
            textString[5] = 'S'
            break
          case '星期日':
            textString[6] = 'S'
            break
          default:
            break
        }
      })
      textString = textString.join('')
      if (this.formDatas.id) {
        for (let i = 0; i < this.timeChartList.length; i++) {
          if (this.timeChartList[i].id === this.formDatas.id) {
            // delete  
            this.timeChartList.splice(i, 1)
            let from = ''
            let to = ''
            let startTime = ''
            let endTime = ''
            if (this.formDatas.isYear && !this.formDatas.isWeek) {
              from = '****-' + moment(this.formDatas.formDate).format('YYYY-MM-DD').substr(5, 10)
              to = '****-' + moment(this.formDatas.toDate).format('YYYY-MM-DD').substr(5, 10)
            } else if (this.formDatas.isWeek) {
              from = '-'
              to = '-'
            } else {
              from = moment(this.formDatas.formDate).format('YYYY-MM-DD')
              to = moment(this.formDatas.toDate).format('YYYY-MM-DD')
            }
            switch (this.timeType) {
              case 1:
                startTime = moment(this.formDatas.startTime).format('HH:mm')
                endTime = moment(this.formDatas.stopTime).format('HH:mm')
                break
              case 2:
                startTime = '00:00'
                endTime = '24:00'
                break
              case 3:
                startTime = '00:00'
                endTime = '00:00'
                break
              default:
                break
            }
            let period = ''
            if (this.formDatas.isWeek && !this.formDatas.isYear) {
              period = 'week'
            } else if (!this.formDatas.isWeek && this.formDatas.isYear) {
              period = 'year'
            } else {
              period = 'day'
            }

            this.timeChartList.push({
              id: this.formDatas.id,
              formDate: from,
              toDate: to,
              startTime: startTime,
              stopTime: endTime,
              weekDays: textString,
              isTime: this.timeType,
              period: period
            })
          }
        }
      } else {
        let from = ''
        let to = ''
        let startTime = ''
        let endTime = ''
        if (this.formDatas.isYear && !this.formDatas.isWeek) {
          from = '****-' + moment(this.formDatas.formDate).format('YYYY-MM-DD').substr(5, 10)
          to = '****-' + moment(this.formDatas.toDate).format('YYYY-MM-DD').substr(5, 10)
        } else if (this.formDatas.isWeek) {
          from = '-'
          to = '-'
        } else {
          from = moment(this.formDatas.formDate).format('YYYY-MM-DD')
          to = moment(this.formDatas.toDate).format('YYYY-MM-DD')
        }
        switch (this.timeType) {
          case 1:
            startTime = moment(this.formDatas.startTime).format('HH:mm')
            endTime = moment(this.formDatas.stopTime).format('HH:mm')
            break
          case 2:
            startTime = '00:00'
            endTime = '24:00'
            break
          case 3:
            startTime = '00:00'
            endTime = '00:00'
            break
          default:
            break
        }
        let period = ''
        if (this.formDatas.isWeek && !this.formDatas.isYear) {
          period = 'week'
        } else if (!this.formDatas.isWeek && this.formDatas.isYear) {
          period = 'year'
        } else {
          period = 'day'
        }
        this.timeChartList.push({
          id: 'id' + moment().format('HH:mm:ss'),
          formDate: from,
          toDate: to,
          startTime: startTime,
          stopTime: endTime,
          weekDays: textString,
          isTime: this.timeType,
          period: period
        })
      }
      this.eventsList = this.timeChartList
      this.visibleData = false
    },
    compareValue() {
      if (this.form.startTime && this.form.stopTime) {
        let start = moment(this.form.startTime)
        let end = moment(this.form.stopTime)
        let startHour = start.hour()
        let endHour = end.hour()
        let startMin = start.minute()
        let endMin = end.minute()
        let finalstart = startHour * 60 * 60 + startMin * 60
        let finalend = endHour * 60 * 60 + endMin * 60
        if (finalstart > finalend) {
          this.$Message.error('您选择的时间有误')
          this.form.startTime = moment()
          this.form.stopTime = moment()
          return false
        }
      }
    },
    handleCheckAllChange(event) {
      this.checkedCities = event.target.checked ? timeOptions : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount > 0
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
    },
    beforeCloseData() {
      this.visibleData = false
    },
    handleCloseHelp() {
      this.dialogHelp = false
    },
    getCurrentYearMonth() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      return `${year}-${month}`
    },
    selectData() {
      const [year, month] = this.timeRange.split('-')

      service.getCalendarData(year, month).then(res => {
        const normalize = item => ({
          ...item,
          isHoliday: !!item.isHoliday,
          isWorkdayDuringHoliday: !!item.isWorkdayDuringHoliday,
          isWeekend: item.weekday === 5 || item.weekday === 6,
          holidayName: item.holidayName === 'NULL' ? '' : item.holidayName
        })

        // ① 真实业务数据
        this.calendarData = res.map(item => normalize(item))

        // ② 原始快照（深拷贝）
        this.originCalendarList = this.calendarData.map(item =>
          JSON.parse(JSON.stringify(item))
        )

        // ③ 仅用于渲染
        this.calendarList = this.formatCalendar(this.calendarData)

        this.modifiedList = []
      })
    },

    isBlueDay(item) {
      if (item.empty) return false
      if (item.isWorkdayDuringHoliday) return false
      return item.isHoliday || item.isWeekend
    },

    // 点击日期的业务逻辑
    onDayClick(item) {
      if (item.empty) return

      // ⚠️ 关键点：item 本身就是 calendarData 里的对象引用
      if (item.isWeekend) {
        item.isWorkdayDuringHoliday = !item.isWorkdayDuringHoliday
      } else {
        item.isHoliday = !item.isHoliday
      }

      this.collectModified(item)
    },
    collectModified(item) {
      const origin = this.originCalendarList.find(d => d.id === item.id)
      if (!origin) return

      const isChanged =
        item.isHoliday !== origin.isHoliday ||
        item.isWorkdayDuringHoliday !== origin.isWorkdayDuringHoliday

      const index = this.modifiedList.findIndex(d => d.id === item.id)

      if (isChanged) {
        if (index === -1) {
          this.modifiedList.push({ ...item })
        } else {
          this.modifiedList.splice(index, 1, { ...item })
        }
      } else {
        if (index !== -1) {
          this.modifiedList.splice(index, 1)
        }
      }
    },
    onMonthChange(val) {
      if (!val) return
      this.selectData()
    },
    saveOver() {

    },
    formatCalendar(list) {
      if (!list || !list.length) return []

      const firstWeekday = (list[0].weekday + 1) % 7

      const emptyList = Array.from({ length: firstWeekday }, (_, i) => ({
        empty: true,
        id: `empty-${i}`
      }))

      return [...emptyList, ...list]
    },
  }
}
</script>
<style scoped>
.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.seventy-part {
  box-sizing: border-box;
  float: left;
  width: 65%;
}

.thirty-part {
  box-sizing: border-box;
  float: left;
  margin-left: 10%;
  width: 70%;
}

.event-btn {
  margin: 10px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.border-main {
  display: flex;
  justify-content: center;
}

.calendar {
  width: 100%;
  color: #fff;
  background-color: transparent;
}

.calendar-header,
.calendar-body {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background: transparent !important;
}

.week {
  text-align: center;
  padding: 10px 0;
  background: transparent !important;
  font-size: 12px;
  /* 强制透明 */
}

.day {
  height: 48px;
  width: 50px;
  font-size: 12px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background-color: rgba(0, 0, 0, 0);
  /* 真·透明 */
  padding: 6px;
  cursor: pointer;
  background: transparent;
  transition: background 0.2s;
}

.day:hover {
  /* 蓝色透明 */
  border: 1px solid #0074E8;
}

.day.active {
  background-color: #0074E8;
  /* 蓝色高亮 */
}

.day-number {
  font-size: 12px;
}

.lunar {
  font-size: 12px;
  opacity: 0.7;
}

/* 高亮状态 */
.holiday {
  background: #0074E8;
  /* 金色半透明 */
}
</style>


// WEBPACK FOOTER //
// src/components/timeChart/holidayPianning.vue